import { render, staticRenderFns } from "./InjectForm.vue?vue&type=template&id=0cbed655"
import script from "./InjectForm.vue?vue&type=script&lang=js"
export * from "./InjectForm.vue?vue&type=script&lang=js"
import style0 from "./InjectForm.vue?vue&type=style&index=0&id=0cbed655&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports